<template>
  <div>
    <BreadCrumbs v-bind:bcrumbs="bcrumbs" />

    <PageTitle v-bind:title="title" v-bind:admin="true" />

    <Loader v-if="loading" />
    <div v-else-if="data.id" class="max-w-lg mx-auto py-8">
      <form class="space-y-4">
        <input type="hidden" name="id" v-model="data.id" />

        <div>
          <label for="text" class="block text-sm font-medium text-gray-700">
            Ответ
          </label>
          <div class="mt-1">
            <input
              v-model="data.text"
              type="text"
              name="text"
              id="text"
              autocomplete="text"
              class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
            />
            <p
              v-if="errors.validationEdit && errors.validationEdit.text"
              class="mt-2 text-sm text-red-600"
            >
              {{ errors.validationEdit.text[0] }}
            </p>
          </div>
        </div>
        <div>
          <div class="relative flex items-start">
            <div class="flex items-center h-5">
              <input
                v-model="data.correct"
                id="correct"
                name="correct"
                type="checkbox"
                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
              />
            </div>
            <div class="ml-3 text-sm">
              <label for="correct" class="font-medium text-gray-700"
                >Это правильный ответ</label
              >
            </div>
          </div>
        </div>

        <div>
          <div class="flex justify-end">
            <button
              @click.prevent="editRecord()"
              type="submit"
              class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Сохранить изменения
            </button>
          </div>
          <ErrorMessage v-if="errors.edit" :error="errors.edit" class="mt-2" />
        </div>
      </form>


    </div>
  </div>
</template>
<script>
import axios from "axios";
import Loader from "@/components/Loader";
import BreadCrumbs from "@/components/BreadCrumbs";
import PageTitle from "@/components/PageTitle";
import ErrorMessage from "../components/ErrorMessage.vue";

export default {
  components: {
    Loader,
    BreadCrumbs,
    PageTitle,
    ErrorMessage,
  },

  data() {
    return {
      loading: true,
      data: [],
      errors: { load: "", edit: "", validationEdit: {} },
      bcrumbs: [],
      title: "Редактирование ответа",
    };
  },

  async mounted() {
    this.loadData();
  },

  methods: {
    async loadData() {
      this.errors.load = "";
      try {
        this.loading = true;
        let response = await axios.get(
          "admin/solutions/" + this.$route.params.id + "/edit"
        );
        this.data = response.data.solution;
        this.bcrumbs = response.data.bcrumbs;
        this.loading = false;
      } catch (e) {
        this.errors.load = "Ошибка при загрузке данных";
      }
    },

    //
    // Edit record.
    //
    async editRecord() {
      this.errors.validationEdit = {};
      this.errors.edit = "";
      try {
        let response = await axios.post(
          "admin/solutions/" + this.data.id,
          Object.assign(this.data, { _method: "PUT" })
        );
        if (response.status == 200) {
          this.loadData();
        }
      } catch (e) {
        if (e.response.status == 422) {
          this.errors.validationEdit = e.response.data.errors;
        } else if (e.response.status == 520) {
          this.errors.edit = e.response.data.error;
        } else {
          this.errors.edit = "Неизвестная ошибка при редактировании записи.";
        }
      }
    },
  },
};
</script>